//#region Styles
import {
    Row, 
    Column, 
    SubtitleSection 
} from "components/styles";
//#endregion
//#region Components
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import CustomTime from "components/CustomTimePicker/CustomTimePicker";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import InactivityBlock from "views/components/Duration/InactivityBlock/InactivityBlock";
import { ERROR_TEXT_LIST } from "../utils/constants";
import { useEffect, useState } from "react";
import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
//#endregion

const OnlyDayFields = ({
    duration, changeDuration, 
    changeErrorText, errors, errorTexts,
    ratioMinutesTimeForTimePickers,
    direction = "row",
    disableControls,
    isEdit = false,
    showInactivitySummaryCard = false,
    hasWaitlist,
    toggleHasWaitlist = () => {},
    isConferenceOrActivity,
    isRefuerzo
}) => {
    const { date, time, waitlist } = duration;
    const [hasWaitlistLocal, setWaitlist] = useState(hasWaitlist);

    useEffect(() => {
        toggleHasWaitlist(hasWaitlistLocal);
    }, [hasWaitlistLocal, toggleHasWaitlist])
    useEffect(() => {
        if (hasWaitlistLocal) {
            let waitlistMinus2 = new Date(date);
            waitlistMinus2.setDate(waitlistMinus2.getDate()-2);
            changeDate("waitlist", waitlistMinus2.getTime())
        }
        
    }, [date])
    const changeToggleWaitlist = () => {
        if(date>0){
            let waitlistMinus2 = new Date(date);
            waitlistMinus2.setDate(waitlistMinus2.getDate()-2);
            changeDate("waitlist", waitlistMinus2.getTime())
        }
        
        setWaitlist(prev => {
            prev && changeDate("waitlist", -1)
            return !prev;
        });
    };
    const changeTime = (field, value) => {
        const currentStartTime = field === "start" ? value : time.start;
        const currentEndTime = field === "end" ? value : time.end;
        changeDuration({
            ...duration, 
            time: {
                ...duration.time,
                [field]: value 
            }
        }, {
            ...errors, 
            time: {
                ...errors.time, 
                [field]: false
            },
            areInvalidTimes: (
                currentStartTime >= 0 && 
                currentEndTime >= 0 && 
                currentStartTime >= currentEndTime 
            )
        });
        if (!changeErrorText) return;
        changeErrorText("invalidTimes", ERROR_TEXT_LIST.INVALID_TIMES);
    }
    const changeInactivity = (value, errorValue) => {
        changeDuration({
            ...duration, 
            time: {
                ...duration.time,
                inactivity: value,
            }
        }, {
            ...errors, 
            time: {
                ...errors.time, 
                inactivity: errorValue
            },
        });
    }
    const changeDate = (field, value) => {
        changeDuration({
            ...duration, 
            [field]: value
        }, {
            ...errors,
            [field]: false
        });
    }
    const renderControls = () => {
        return (
            <>
            <Column gap="23px"
            width="max-content">
                <SubtitleSection>Fecha:</SubtitleSection>
                <CustomDatePicker 
                    label="Selecciona el día:"
                    value={date}
                    onChange={(value) => changeDate('date', value)}
                    error={errors.date}
                    errorText="Es necesario seleccionar una fecha."
                    disabled={disableControls}/>
            </Column>
            <Column gap="23px" width="max-content">
                <SubtitleSection>Horario:</SubtitleSection>
                <Column>
                    <Row>
                        <CustomTime 
                            label="Desde:"
                            caption="Desde:"
                            value={time.start}
                            onChange={value => changeTime("start", value)}
                            ratioMinutesTime={ratioMinutesTimeForTimePickers}
                            error={errors.time.start || errors.areInvalidTimes}
                            disabled={disableControls}
                            errorText={!errors.areInvalidTimes ? 
                                "Es necesario seleccionar una hora inicial."
                            : null}/>
                        <CustomTime 
                            label="Hasta:"
                            caption="Hasta:"
                            value={time.end}
                            onChange={value => changeTime("end", value)}
                            ratioMinutesTime={ratioMinutesTimeForTimePickers}
                            error={errors.time.end || errors.areInvalidTimes}
                            disabled={disableControls}
                            errorText={!errors.areInvalidTimes ? 
                                "Es necesario seleccionar una hora final."
                            : null}/>
                    </Row>
                    <ErrorMessage 
                        error={errors.areInvalidTimes}
                        text={errorTexts?.invalidTimes || ERROR_TEXT_LIST.INVALID_TIMES}/>
                </Column>
                {time.inactivity && 
                <InactivityBlock 
                    duration={duration}
                    changeInactivity={changeInactivity}
                    ratioMinutesTime={ratioMinutesTimeForTimePickers}
                    showSummaryCard={showInactivitySummaryCard}
                    errors={errors}
                    date={date}/>}
            </Column>
            <Column>
                    {!isEdit && !disableControls && (isConferenceOrActivity || isRefuerzo) && (
                        <CustomCheckbox
                            label="Configurar lista de espera"
                            variant="switch"  
                            disabled={disableControls}                      
                            checked={hasWaitlistLocal}
                            onChange={changeToggleWaitlist}
                        />
                    )}
                    {(hasWaitlistLocal || waitlist > 0) && (isConferenceOrActivity || isRefuerzo) && (
                        <Column>
                            <CustomDatePicker
                                label="Fecha límite en la cual se visualizará la opción de lista de espera:"
                                value={waitlist}
                                disabled={true}
                                error={errors.waitlist}
                                errorText="Es necesario seleccionar una fecha limite de lista de espera." />
                            <ErrorMessage
                                error={errors.isValidWaitlist}
                                text="La fecha límite de lista de espera debe estar entre la fecha inicio y fin del evento" />
                        </Column>                        
                    )}
            </Column>
            </>
        );
    }
    return (
        direction === "row" 
        ? <Row className="flex-start" 
            gap="30px">
            {renderControls()}
        </Row> 
        : direction === "column" 
        ? <Column gap="40px">
            {renderControls()}
        </Column> : null
    );
}

export default OnlyDayFields;
